import logo from './../../assets/logo-sm-light.png';
import './Logo.scss';


const Logo = ({ alt, size })=> {
    return (
        <div className="logo-container">
            <img src={logo} alt={alt} className={`logo-${size}`} />
        </div>
    );
};

export default Logo;
